import React, { useState, useEffect } from 'react';
import { FiChevronLeft, FiLogOut, FiUserX, FiSun, FiMoon } from 'react-icons/fi';
import axios from 'axios';

// ==================== axios 인스턴스 (공통) ====================
const API_URL = process.env.REACT_APP_API_URL;
const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use((cfg) => {
  const tk = localStorage.getItem('accessToken');
  if (tk) cfg.headers.Authorization = `Bearer ${tk}`;
  return cfg;
});

export default function MyScreen({ onBack, user }) {
  const defaultProfile = { level: 1, nickname: 'Guest', job: '모험가', exp: 0 };
  const profile = user?.profile ?? defaultProfile;

  // ---------------------- 다크/라이트 모드 ----------------------
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "dark"
  );

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);
      
    // HomeScreen이 즉시 알아차릴 수 있도록 커스텀 이벤트 발송
    window.dispatchEvent(new Event('theme-changed'));
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === 'light' ? 'dark' : 'light'));

  // --------------------------- 색상 -----------------------------
  const COLORS = {
    light: {
      bg: '#F8F6F2',
      card: '#FFFFFF',
      text: '#333333',
      gray: '#888888',
      primary: '#DBD1BD',
    },
    dark: {
      bg: '#1A1A2E',
      card: '#1E3A52',
      text: '#F0F0F3',
      gray: '#AAAAAA',
      primary: '#FFB627',
    },
  };
  const C = COLORS[theme];

  // ---------------------- 로그아웃 ----------------------
  const handleLogout = () => {
    if (!window.confirm('로그아웃하시겠습니까?')) return;
    localStorage.clear();
    window.location.reload();
  };

  // ---------------------- 회원탈퇴 ----------------------
  const handleWithdraw = async () => {
    if (!window.confirm('정말 탈퇴하시겠습니까? 모든 데이터가 삭제됩니다.')) return;
    try {
      // 👉 DELETE /auth/delete (계정 삭제)
      const res = await api.delete('/auth/delete');
      alert(res.data?.message || '탈퇴가 완료되었습니다.');
      localStorage.clear();
      window.location.reload();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401) {
        alert('인증 정보가 만료되었습니다. 다시 로그인 후 시도해 주세요.');
      } else if (status === 404) {
        alert('사용자 정보를 찾을 수 없습니다.');
      } else {
        alert('탈퇴에 실패했습니다. 잠시 후 다시 시도해 주세요.');
      }
      console.error('회원탈퇴 실패:', err.response ?? err);
    }
  };

  // --------------------------- UI -----------------------------
  return (
    <div
      style={{
        width: 393,
        minHeight: '100vh',
        margin: '0 auto',
        background: C.bg,
        fontFamily: "'Pretendard','Spline Sans','SF Pro',sans-serif",
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* ---------------- 헤더 ---------------- */}
      <header
        style={{
          height: 56,
          display: 'flex',
          alignItems: 'center',
          padding: '0 12px',
          borderBottom: `1px solid ${C.gray}`,
          background: C.bg,
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <button
          onClick={onBack}
          style={{
            background: 'none',
            border: 'none',
            fontSize: 24,
            cursor: 'pointer',
            color: C.text,
            marginRight: 8,
          }}
          aria-label="뒤로가기"
        >
          <FiChevronLeft />
        </button>
        <h1
          style={{
            flex: 1,
            fontSize: 20,
            fontWeight: 700,
            color: C.text,
            textAlign: 'center',
          }}
        >
          내 정보
        </h1>
        <button
          onClick={toggleTheme}
          style={{
            background: 'none',
            border: 'none',
            fontSize: 24,
            cursor: 'pointer',
            color: C.text,
          }}
          aria-label="테마 전환"
        >
          {theme === 'dark' ? <FiSun /> : <FiMoon />}
        </button>
      </header>

      {/* ---------------- 본문 ---------------- */}
      <div style={{ flex: 1, padding: 20 }}>
        {/* 프로필 카드 */}
        <div
          style={{
            background: C.card,
            borderRadius: 12,
            padding: 16,
            marginBottom: 24,
            color: C.text,
          }}
        >
          <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>
            프로필
          </div>
          <p>
            <strong>닉네임:</strong> {profile.nickname}
          </p>
          <p>
            <strong>레벨:</strong> {profile.level}
          </p>
          <p>
            <strong>직업:</strong> {profile.job}
          </p>
        </div>

        {/* 버튼들 */}
        <button
          onClick={handleLogout}
          style={{
            width: '100%',
            padding: 14,
            background: C.primary,
            border: 'none',
            borderRadius: 12,
            fontWeight: 700,
            fontSize: 15,
            marginBottom: 12,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            color: C.text,
            cursor: 'pointer',
          }}
        >
          <FiLogOut size={18} /> 로그아웃
        </button>

        <button
          onClick={handleWithdraw}
          style={{
            width: '100%',
            padding: 14,
            background: '#F25C5C',
            border: 'none',
            borderRadius: 12,
            fontWeight: 700,
            fontSize: 15,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            color: '#FFFFFF',
            cursor: 'pointer',
          }}
        >
          <FiUserX size={18} /> 회원 탈퇴
        </button>
      </div>
    </div>
  );
}
